export const SEARCH_PARAMS = {
  FEEDBACK: 'feedback',
  LANGUAGE: 'lang',
  LOCALE: 'locale',
  COUNTRY_FILTER: 'fl'
}
